import { Table } from 'dexie';
import db, { DataRepository, Database, Key } from '@/db';
import { PutterFaceForSaveDto } from '../../api/models';

export type TABLE_TYPE = Table<PutterFaceForSaveDto>;

export const TABLE = 'putterFace';
const SCHEMA = 'putterFaceId, sortId';

class PutterFaceDatabase implements DataRepository<PutterFaceForSaveDto> {
  constructor(private db: Database) {
    db.registerModelSchema(TABLE, SCHEMA);
  }

  get(key: Key): Promise<PutterFaceForSaveDto | undefined> {
    return this.db[TABLE].get(key);
  }

  delete(key: Key): Promise<void> {
    return this.db[TABLE].delete(key);
  }

  update(payload: PutterFaceForSaveDto, key: Key): Promise<PutterFaceForSaveDto> {
    return this.db[TABLE].put(payload, key);
  }

  async bulkAdd(payload: PutterFaceForSaveDto[]): Promise<PutterFaceForSaveDto[]> {
    await this.db[TABLE].clear();
    return this.db[TABLE].bulkPut(payload);
  }

  list(): Promise<PutterFaceForSaveDto[]> {
    return this.db[TABLE].orderBy('sortId').toArray();
  }
}

export const PutterFaceDB = new PutterFaceDatabase(db);
